import React from 'react'
import {withFormImageInput, FileInput} from 'startlibs/lib/form'
import {Button} from 'startlibs/lib/components'
import {ice} from 'icepath'
import {defaultMemoize} from 'reselect'

@withFormImageInput(
  function preValidate(file) {
    if (file.size > 4194304) {
      return ['Your file needs to be smaller than 4mb.']
    }
    if (['image/gif', 'image/png', 'image/jpeg', 'image/jpg'].indexOf(file.type.toLowerCase()) < 0) {
      return ['Invalid file format. Please select a .JPG or .PNG file.']
    }
  },
  function uploadFetcher(file, props) {
    const formData = new FormData()
    formData.append('file', file)
    return props.uploadFetcher(formData, '').then(({resourceUID}) => ({image: resourceUID, uploadStatus: 'upload-finished'}))
  }
)
export class AvatarUploadForm extends React.Component {
  state = {}

  handleDrop = (e) => {
    const {handleFile} = this.props
    e.preventDefault()
    const files = (e.nativeEvent.dataTransfer || e.nativeEvent.target).files
    if (files.length > 0) {
      const file = files[0]
      handleFile(file)
    }
    this.setState({isDragging: false})
  }

  removePicture = () => this.props.form.connector.setValue(this.props.path,this.props.defaultPicture)

  memoizedBackground = defaultMemoize((i)=> (typeof i === "string" ? `url("${this.props.getResource(i)}")` : `url("${URL.createObjectURL(i)}")`))

  getImage = () => ice.get(this.props.form.properties,this.props.path) || this.props.defaultPicture

  getBackground = () => this.getImage() && !this.state.isDragging ? ({backgroundImage: this.memoizedBackground(this.getImage()) }) : {}

  render() {
    const {label,form, path} = this.props
    // const {isDragging} = this.state
    const uploadStatus = ice.get(form.meta, ice.toPath(path).concat('uploadStatus'))
    return (
      <form className={`user-avatar-form ${uploadStatus} box`}>
        <div className="img-wrapper user-avatar" style={this.getBackground()}>
          <label className="img-upload">
            <FileInput onChange={this.handleDrop} tabIndex={-1}/>
          </label>
        </div>
        <div className="actions-wrapper">
          <input type="hidden" value="avatar" name="_imageName" tabIndex={-1}/>
          <div className="button highlight">
            Upload new
            <FileInput onChange={this.handleDrop} tabIndex={-1}/>
          </div>
          <Button onClick={this.removePicture} tabIndex={-1}>Remove picture</Button>
        </div>
        <div className="loader-container">
          <div className="uploading-image-loader"><span className="loader"/><span className="loader-text">Uploading</span>
          </div>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/components/AvatarUploadForm.jsx